export const dragStateEnum = {
  none: "none",
  select: "select",
  drag: "drag",
  group: "group",
  scaling: "scaling",
};

export const SMStateEnum = {
  none: "none",
  select: "select",
  drag: "drag",
};

export const fitFlagEnum = {
  fit: "fit",
  xFit: "xfit",
  upper: "upper",
  lower: "lower",
  upperLeft: "upperLeft",
  upperRight: "upperRight",
  lowerLeft: "lowerLeft",
  lowerRight: "lowerRight",
};

export const eventNameEnum = {
  none: "none",
  write: "write",
  erase: "erase",
  multiSelect: "multiSelect",
  addRect: "addRect",
  addLine: "addLine",
  addText: "addText",
  addPath: "addPath",
  addStars: "addStars",
  addImage: "addImage",
  save: "save",
  load: "read",
  windowChange: "windowChange",
};

export const svgTypeEnum = {
  rect: "r",
  line: "l",
  text: "t",
  path: "p",
  stars: "s",
  image: "i",
};

export const groupingStateEnum = {
  none: 0,
  grouping: 1,
};

export const arrowKeysEnum = {
  left: "ArrowLeft",
  right: "ArrowRight",
  up: "ArrowUp",
  down: "ArrowDown",
};

export const cursorModeEnum = {
  default: "default",
  write: "write",
  erase: "erase",
};
